import baseApi from "../api/baseApi";

const instructorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstructorProfile: builder.query({
      query: () => ({
        url: "/instructor/getInstructorProfile",
        method: "GET",
      }),
      providesTags: ["InstructorProfile"],
    }),

    updateInstructorInformation: builder.mutation({
      query: (body) => ({
        url: "/instructor/updateInstructorInformation",
        method: "PATCH",
        credentials: "include",
        body,
      }),
      invalidatesTags: ["InstructorProfile"],
    }),
    updateInstructorAcademicDetails: builder.mutation({
      query: (body) => ({
        url: "/instructor/updateInstructorAcademicDetails",
        method: "PATCH",
        body,
      }),
      invalidatesTags: ["InstructorProfile"],
    }),
    verifyInstructorTranscriptUsingAi: builder.mutation({
      query: () => ({
        url: "/instructor/verify-instructor-transcript-using-ai",
        method: "PATCH",
        credentials: "include",
      }),
    }),
    getInstructorMySlots: builder.query({
      query: () => ({
        url: "/instructor/availability/mySlots",
        method: "GET",
      }),
    }),

    getMyAssignedCourses: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `/instructor/getMyAssignedCourses?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),
    getCourseById: builder.query({
      query: (id) => ({
        url: `/instructor/getCourseById/${id}`,
        method: "GET",
      }),
    }),
    getAllCourseModuleUserSide: builder.query({
      query: (courseId) => ({
        url: `/coursemodules/getAllCourseModuleUserSide/${courseId}`,
        method: "GET",
      }),
    }),
    getInstructorWiseAllCourseFeedback: builder.query({
      query: () => ({
        url: "/coursefeedback/getInstructorWiseAllCourseFeedback",
        method: "GET",
      }),
    }),
    getInstructorMySessions: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/coursesession/instructor/my-sessions?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),
    getInstructorDemoSessions: builder.query({
      query: () => ({
        url: `/demosession/getInstructorDemoSessions`,
        method: "GET",
      }),
    }),
    getInstructorSessionModulesDetail: builder.query({
      query: (sessionId) => ({
        url: `/coursesession/instructor/${sessionId}/modules-detail`,
        method: "GET",
      }),
    }),
    getInstructorSessionStudents: builder.query({
      query: (sessionId) => ({
        url: `/coursesession/instructor/${sessionId}/students`,
        method: "GET",
      }),
    }),
    markInstructorSessionModuleComplete: builder.mutation({
      query: ({ sessionId, moduleId }) => ({
        url: `/coursesession/instructor/${sessionId}/modules/${moduleId}/mark-complete`,
        method: "PATCH",
      }),
    }),
    deleteInstructorSlot: builder.mutation({
      query: (slotId) => ({
        url: `/instructor/availability/deleteSlot/${slotId}`,
        method: "DELETE",
      }),
    }),
    createInstructorSlot: builder.mutation({
      query: (body) => ({
        url: "/instructor/availability/createSlot",
        method: "POST",
        body,
      }),
    }),
    updateInstructorSlot: builder.mutation({
      query: ({ slotId, body }) => ({
        url: `/instructor/availability/updateSlot/${slotId}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
});

export const {
  useGetInstructorProfileQuery,
  useUpdateInstructorInformationMutation,
  useUpdateInstructorAcademicDetailsMutation,
  useVerifyInstructorTranscriptUsingAiMutation,
  useGetInstructorMySlotsQuery,
  useGetMyAssignedCoursesQuery,
  useGetCourseByIdQuery,
  useGetAllCourseModuleUserSideQuery,
  useGetInstructorWiseAllCourseFeedbackQuery,
  useGetInstructorMySessionsQuery,
  useGetInstructorDemoSessionsQuery,
  useGetInstructorSessionModulesDetailQuery,
  useGetInstructorSessionStudentsQuery,
  useMarkInstructorSessionModuleCompleteMutation,
  useDeleteInstructorSlotMutation,
  useCreateInstructorSlotMutation,
  useUpdateInstructorSlotMutation,
} = instructorApi;

export default instructorApi;
